exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome-customizeyourstay-component{padding-bottom:24px}.welcome-customizeyourstay-component .well{height:350px}@media (max-width:768px){.welcome-customizeyourstay-component .well{padding-right:0!important;padding-left:0!important}}.welcome-customizeyourstay-component__title{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/welcome/customizeyourstay.scss
// module id = 1038
// module chunks = 0